import validate from '../../../services/reduxValidate.js';

export default function (data) {
  const options = {
    "user.firstname": {
      presence: {
        allowEmpty: false,
        message: 'Vous devez renseigner votre prénom'
      }
    },
    "user.lastname": {
      presence: {
        allowEmpty: false,
        message: 'Vous devez renseigner votre nom'
      }
    },
    "user.tel": {
      presence: {allowEmpty: false},
      format: {
        pattern: /^\+?([0-9.\-\s]+)$/g,
        message: "Le numéro de téléphone est invalide (format souhaité : +33612345678)"
      }
    },
  };

  return validate(data, options);
}
